import React, { useEffect, useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { ProductBreakdown } from './components/ProductBreakdown';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { PricingSection } from './components/PricingSection';
import { AutopilotSection } from './components/AutopilotSection';
import { MoreTestimonials } from './components/MoreTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the hero section
      if (window.scrollY > 600) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-primary/20 selection:text-primary" data-id="element-0">
      <HeroSection data-id="element-1" />
      <SocialProof data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <ProductBreakdown data-id="element-5" />
      <BonusSection data-id="element-6" />
      <UrgencySection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <AutopilotSection data-id="element-9" />
      <MoreTestimonials data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <CostComparison data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />

      {/* Mobile Sticky CTA */}
      <div className={`fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-[0_-10px_20px_rgba(0,0,0,0.05)] transform transition-transform duration-300 z-50 md:hidden ${showStickyCTA ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-16">
        <a href="#pricing" className="flex items-center justify-center w-full py-3 px-4 bg-gradient-to-r from-primary to-secondary text-white font-bold rounded-xl shadow-lg" data-id="element-17">
          QUIERO MI MEGAPACK
        </a>
      </div>
    </div>;
}